export default __webpack_public_path__ + "resources/icons/d110-ae8a.png";